<template>
  <div class="pa-4">
    <v-card
      class="mb-2"
      style="border: 1px solid #eee; box-shadow: none"
      v-for="item in items"
      :key="item.key"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">{{
              item.name
            }}</v-list-item-title>
          <v-list-item-subtitle v-if="item.caption">{{
              item.caption
            }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action> ${{ item.price }} </v-list-item-action>
      </v-list-item>
    </v-card>
    <div class="text-right mr-4 font-weight-medium py-2 rounded-lg">
      Total: ${{ total }}
    </div>
    <div class="mt-6">
      <credit-card-form
        @submit="purchase"
        btn-label="Confirm & Pay"
        :loading.sync="loading"
      />
      <v-img
        src="@/assets/stripe-badge-sm3.png"
        width="340"
        class="d-block mx-auto mt-4"
      ></v-img>
      <div class="text-center mt-4">
        <a
          href="https://www.reviews.co.uk//company-reviews/store/www.willed.com.au"
          target="_blank"
        >
          <img
            src="https://s3-eu-west-1.amazonaws.com/reviews-global/images/trust-badges/reviews-trust-logo-1.png"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import { functions } from "../../../plugins/firebase"
import CreditCardForm from "./CreditCardForm"
export default {
  name: "PaymentCheckout",
  components: { CreditCardForm },
  props: {
    total: {
      default: null,
    },
    items: {
      default: () => [],
    },
    includesPartner: {
      default: false,
    },
    subscriptionPlan: {
      default: null,
    },
    promoCode: {
      default: null,
    },
    prepaidCode: {
      default: null,
    },
    referrerId: {
      default: null,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async purchase(token) {
      functions
        .httpsCallable("clientPurchaseProducts")({
          uid: this.$store.getters["account/auth_user"].uid,
          tokenId: token.id,
          price: this.total,
          product: this.mainProduct,
          plan: this.subscriptionPlan,
          partner: this.includesPartner,
          promoCode: this.promoCode,
          prepaidCode: this.prepaidCode,
        })
        .then(async (resp) => {
          if (resp.data.status === "completed") {
            let query = {
              pt: "s",
              pd: this.total,
              pn: this.mainProduct,
            }
            if (this.promoCode) {
              query.pc = this.promoCode
            }
            if (this.prepaidCode) {
              query.pp = this.prepaidCode
            }

            await this.$router.push({ path: "/", query: query })
          }
        })
        .catch((err) => {
          this.$store.commit("app/SET_MESSAGE", {
            type: "error",
            text: err,
          })
          this.loading = false
        })
    },
  },
  computed: {
    ...mapGetters("app", ["pricing"]),
    mainProduct() {
      let product = this.subscriptionPlan ? "subscription" : "will"
      this.items.forEach((item) => {
        product = item.key === "will" ? "will" : product
      })

      return product
    },
  },
}
</script>

<style scoped>
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

#card-error {
  color: red;
}
</style>
